import React, { FC, useCallback } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import { createGlobalStyle } from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

type AutocompleteProps = {
  Listoption: any;
  onChangeValue: any;
  id: any;
  defaultValue?: any;
  placeholder?: string;
};

const AutocompleteComponent: FC<AutocompleteProps> = (props) => {
  return (
    <Container>
      <Styles />
      <Autocomplete
        id={props.id}
        sx={{ width: 'auto', backgroundColor: 'rgb(237, 242, 250)' }}
        options={props.Listoption}
        autoHighlight
        getOptionLabel={(option: any) => option.name}
        isOptionEqualToValue={useCallback(
          (option, value) => option.name === value.name,
          []
        )}
        onChange={props.onChangeValue}
        defaultValue={props.defaultValue}
        renderOption={(e, option) => (
          <Box
            component='li'
            sx={{
              '&:hover': {
                color: '#000000',
                fontWeight: 'bold',
                fontFamily: 'Montserrat, sans-serif',
              },
            }}
            style={{ fontSize: 12, fontFamily: 'Montserrat, sans-serif' }}
            {...e}
          >
            {option.name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={
              props.placeholder !== undefined ? props.placeholder : 'Toutes'
            }
          />
        )}
      />
    </Container>
  );
};

export const Styles = createGlobalStyle`
.sds-reset-style{
  .autocomplete{
    margin-left: 0;
    position: relative;
  }
}
`;

export default AutocompleteComponent;
